import { DELTA_COLORS } from '../lib/chart-theme';

interface KpiCardProps {
    label: string;
    value: string | number;
    delta?: number | null;
    unit?: string;
    loading?: boolean;
}

export function KpiCard({ label, value, delta, unit, loading }: KpiCardProps) {
    if (loading) {
        return (
            <div className="bg-white border border-gray-200 rounded-lg p-4 animate-pulse">
                <div className="h-3 bg-gray-200 rounded w-2/3 mb-3" />
                <div className="h-7 bg-gray-200 rounded w-1/2" />
            </div>
        );
    }

    const deltaColor =
        delta == null ? undefined
        : delta > 0 ? DELTA_COLORS.positive
        : delta < 0 ? DELTA_COLORS.negative
        : DELTA_COLORS.neutral;

    const deltaArrow = delta == null ? '' : delta > 0 ? '▲' : delta < 0 ? '▼' : '—';

    return (
        <div className="bg-white border border-gray-200 rounded-lg p-4">
            <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">{label}</p>
            <p className="text-2xl font-bold text-gray-900">
                {value}
                {unit && <span className="text-sm font-normal text-gray-500 ml-1">{unit}</span>}
            </p>
            {delta != null && (
                <p className="text-xs mt-1 font-medium" style={{ color: deltaColor }}>
                    {deltaArrow} {Math.abs(delta).toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %
                </p>
            )}
        </div>
    );
}
